import React from 'react';
import { cn } from '@v2/utils/cn';
import { Ticket01 } from '@v2/ui/Icon/MapsAndTravel';
import { TrendUp01 } from '@v2/ui/Icon/Charts';
import { ShieldDollar } from '@v2/ui/Icon/General';
import { Users01 } from '@v2/ui/Icon/Users';

const trustItems = [
  {
    id: 'guaranteed-tickets',
    title: 'Guaranteed Tickets',
    description: 'Verified event tickets secured before your trip.',
    Icon: Ticket01,
  },
  {
    id: 'bundle-save',
    title: 'Bundle & Save',
    description: 'Add hotels and flights to unlock exclusive package savings.',
    Icon: TrendUp01,
  },
  {
    id: 'all-in-pricing',
    title: 'All-In Pricing',
    description: 'See your total package price upfront, with no surprise fees.',
    Icon: ShieldDollar,
  },
  {
    id: 'trusted-fans',
    title: 'Trusted by Thousands',
    description: 'Join thousands of fans who book unforgettable trips with us.',
    Icon: Users01,
  },
] as const;

export function TrustFeatures() {
  return (
    <section
      aria-label="Why book with Elite Sports Tours"
      className="w-full rounded-2xl border border-gray-200 bg-white p-5 sm:p-6"
    >
      <ul className="grid grid-cols-2 gap-x-4 gap-y-5 lg:grid-cols-4 lg:gap-0">
        {trustItems.map((item, index) => {
          const Icon = item.Icon;
          return (
            <li
              key={item.id}
              className={cn(
                'flex items-center gap-3 sm:items-start',
                'lg:flex-col lg:gap-3 lg:px-6',
                index > 0 && 'lg:border-l lg:border-gray-200',
                index === 0 && 'lg:pl-0',
                index === trustItems.length - 1 && 'lg:pr-0'
              )}
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-200/80 sm:h-11 sm:w-11">
                <Icon className="h-5 w-5 text-gray-700 sm:h-6 sm:w-6" />
              </div>
              <div className="min-w-0">
                <h3 className="text-[13px] font-semibold leading-snug tracking-tight text-gray-900 sm:text-sm">
                  {item.title}
                </h3>
                <p className="mt-1 hidden text-xs leading-5 text-gray-500 sm:block">
                  {item.description}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
